import type React from 'react';

import type { HNCoreFrontendWebForside } from '../types/Resources';

import Tjenestepanel from '@helsenorge/core-cms/tjenestepanel-v2';
import { getSidetittelId } from '@helsenorge/framework-utils/hn-page';
import { selectCurrentLanguage } from '@helsenorge/framework-utils/language';

import { useAppSelector } from '../store/hooks';
import { useGetTilesQuery } from '../store/tilesApi';

interface Props {
  resources: HNCoreFrontendWebForside;
}

const TjenestepanelContainer: React.FunctionComponent<Props> = ({ resources }: Props) => {
  const language = useAppSelector(state => selectCurrentLanguage(state.language));

  const { data } = useGetTilesQuery(language);

  if (!data) {
    return null;
  }

  return (
    <Tjenestepanel
      titleId={getSidetittelId()}
      showMore={resources.tjenestepanelVisFlere}
      showLess={resources.tjenestepanelVisFarre}
      sharingStatusText={resources.sharing_Status_Delt_Med_Barnet}
      favorites={data?.favoriteTiles}
      groups={data?.tiles}
    />
  );
};

export default TjenestepanelContainer;
